import { useEffect, useState } from "react";
import Footer from "../../components/Footer/Footer";
import Carousel from "react-bootstrap/Carousel";

import "./careers.scss";
import { Link } from "react-router-dom";
import Pagination from "../../components/Pagination/Pagination";
import Spinner from "../../components/Spinner/Spinner";
import career_img1 from "../../assets/img/carreer_img1.png";
import carrer_img2 from "../../assets/img/carreer_img2.png";
import Navbar from "../../components/Navbar/Navbar";
import banner1 from "../../assets/img/careers-images/banners/1.png";
import banner2 from "../../assets/img/careers-images/banners/2.png";
import banner3 from "../../assets/img/careers-images/banners/3.png";

import config from "../../config";

const BASE_URL = config.base_url;
const JOBS_URL = `${BASE_URL}api/get-jobs`;
const JOBS_AND_LOCATION_URL = `${BASE_URL}api/get-location-and-jobs`;

const Careers = () => {
  const [error, setError] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingJobsAndLocations, setIsLoadingJobsAndLocations] =
    useState(false);

  const [items, setItems] = useState([]);
  const [searchJob, setSearchJob] = useState("");
  const [searchLocation, setSearchLocation] = useState("");
  const [myJobs, setMyJobs] = useState([]);

  const searchHandler = async () => {
    if (searchLocation === "" && searchJob === "") {
      alert("Please select either job or location to search");
      return;
    }

    try {
      setIsLoading(true);
      setError("");
      let newUrl = `${JOBS_URL}?job=${searchJob}&location=${searchLocation}`;
      const response = await fetch(newUrl);
      const data = await response.json();
      setMyJobs(data.data);
    } catch (error) {
      setError(error);
      console.log(error, "Error when searching for jobs");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const getJobs = async () => {
      setIsLoading(true);
      setError("");
      try {
        const response = await fetch(JOBS_URL);
        const data = await response.json();
        setMyJobs(data.data);
      } catch (error) {
        console.error("Error fetching jobs:", error);
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };
    getJobs();
  }, []);

  useEffect(() => {
    const getJobsAndLocations = async () => {
      setIsLoadingJobsAndLocations(true);
      setError("");
      try {
        const response = await fetch(JOBS_AND_LOCATION_URL);
        const data = await response.json();
        setItems(data);
      } catch (error) {
        console.error("Error fetching jobs and locations:", error);
        setError(error);
      } finally {
        setIsLoadingJobsAndLocations(false);
      }
    };

    getJobsAndLocations();
  }, []);

  return (
    <div style={{ overflow: "hidden" }} id="careers">
      <Navbar />

      <section className="pt-0 pb-0 position-relative career_slider_breadcrumb banner_image_overlay">
        {/* <img src={career_banner} alt="" className="img-fluid w-100" /> */}
        <Carousel fade>
          <Carousel.Item>
            <img src={banner1} className="d-block w-100" alt="..." />
          </Carousel.Item>
          <Carousel.Item>
            <img src={banner2} className="d-block w-100" alt="..." />
          </Carousel.Item>
          <Carousel.Item>
            <img src={banner3} className="d-block w-100" alt="..." />
          </Carousel.Item>
        </Carousel>
        <div className="breadcrumb_text">
          <h4 className="breadcrumb_title">Careers</h4>
          <p className="breadcrumb_link">
            <Link to="/"> Home</Link> | Careers
          </p>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-4 text-center">
              <img src={career_img1} alt="" className="img-fluid w-25" />
            </div>
            <div className="col-md-8 vision_mission_block ps-4">
              <div className="title  pt-4">
                <h4>JOBS</h4>
              </div>
              <p>
                Ayana Renewable Power is one of India's largest and
                fastest-growing renewable energy companies. In just five years,
                our presence has expanded across India. We are working towards
                developing a contracted capacity of more than 8GW<sub>AC</sub> by 2028 that can provide clean
                power to millions of people.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg_grey" id={"careers"}>
        <div class="container text-center">
          <div class="row justify-content-center g-3">
            <div className="col-md-4">
              <select
                onChange={(e) => setSearchJob(e.target.value)}
                style={{ border: "none" }}
                className="form-select shadow-none border-none"
                aria-label="Default select example"
              >
                <option option selected disabled value="">
                  Job Title
                </option>
                {isLoadingJobsAndLocations ? (
                  <Spinner />
                ) : (
                  items?.jobs?.map((data) => (
                    <>
                      <option value={data.id}>{data.name}</option>
                    </>
                  ))
                )}
              </select>
            </div>
            <div class="col-md-4">
              <div className=" job_drop_down">
                <select
                  onChange={(e) => setSearchLocation(e.target.value)}
                  style={{ border: "none" }}
                  className="form-select shadow-none"
                  aria-label="Default select example3"
                >
                  <option option selected disabled value="">
                    Location
                  </option>
                  {isLoadingJobsAndLocations ? (
                    <Spinner />
                  ) : (
                    items?.locations?.map((data) => (
                      <>
                        <option value={data.id}>{data.name}</option>
                      </>
                    ))
                  )}
                </select>
              </div>
            </div>
            <div className="col-md-2 search_btn_container">
              <button onClick={searchHandler} className="btn btn_blue">
                Search Job
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="bg_grey pos_relative">
        {isLoading ? (
          <Spinner />
        ) : error ? (
          <div>{error}</div>
        ) : myJobs?.length > 0 ? (
          <>
            <Pagination jobs={myJobs || []} itemsPerPage={4} />
            <img src={carrer_img2} alt="" className="img-fluid career_img2" />
          </>
        ) : (
          <div>
            <p className="text-center py-5">No Jobs Found...</p>
          </div>
        )}
      </section>

      <section className="py-5" style={{ display: "none" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10">
              <div
                className="text-center p-5"
                style={{
                  background: "#f8fafc",
                  border: "1px solid #e9ecef",
                  borderRadius: "20px",
                }}
              >
                <div
                  className="d-flex align-items-center justify-content-center mx-auto mb-4"
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    background: "#fff",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    fontSize: "32px",
                  }}
                >
                  💼
                </div>

                <h4 className="mb-3 fw-semibold">
                  No Job Openings Available
                </h4>

                <p
                  className="mb-0 text-muted"
                  style={{
                    maxWidth: "600px",
                    margin: "0 auto",
                    lineHeight: "1.7",
                  }}
                >
                  We don't have any open positions at the moment. However,
                  we're always looking for talented and passionate people to
                  join our team. Please check back soon for new opportunities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Careers;
